<template>
  <div
    id="main"
    :class="
      termsCheck
        ? 'scroll-hidden'
        : '' || (activedVolting && needVoting)
        ? 'scroll-hidden'
        : ''
    "
  >
    <!-- <div class="backgorund_modal"> -->
    <!-- <div class="backgorund_modal" v-if="activedVolting && needVoting">
      <modal-voting-eleven @getVotingStatus="getVotingStatus()"></modal-voting-eleven>
    </div> -->

    <div class="backgorund_modal" v-if="activedVolting && needVoting">
      <modalVotingFourteenVue
        @getVotingStatus="getVotingStatus()"
      ></modalVotingFourteenVue>
    </div>

    <div class="backgorund_modal" v-if="privacyCheck">
      <modal-privacy-policy @closeModal="checkMember()" />
    </div>

    <div class="backgorund_modal" v-if="termsCheck">
      <modal-terms-conditions @closeModal="checkMember()" />
    </div>

    <div
      class="backgorund_modal"
      v-if="modalNotificationBlueClub && needVotingBlueClub"
    >
      <modalNetworkDist
        @closeModalNetwork="postNotificationConfirm"
        :networkId="networkId"
      />
    </div>

    <!-- <div class="backgorund_modal" v-if="modalNotificationBSC && needVotingBSC">
      <modalBscInfo
        @closeModalNetwork="postNotificationConfirm"
        :bluePool="bluePool"
      />
    </div> -->

    <!-- <div class="backgorund_modal" v-if="modalNotificationBluePool && needVotingBluePool">
      <modalPoolInfo
        @closeModalNetwork="postNotificationConfirm"
        :bluePoolId="bluePoolId"
      />
    </div> -->

    <!-- <div
      class="backgorund_modal"
      v-if="modalNotificationDHBT && needVotingDHBT"
    >
      <modalDhbtInfo
        @closeModalNetwork="postNotificationConfirm"
        :dhbId="dhbId"
      />
    </div> -->

    <!-- <div class="backgorund_modal" v-if="modalNotificationDHBT">
      <modalDhbtInfo @closeModalNetwork="postNotificationConfirm()" />
    </div> -->

    <div class="form_bg" v-bind:class="{ form_showing: modal }">
      <div class="form_outside" @click="toggleModal"></div>
      <div class="contact_form">
        <div class="contact_form_body">
          <div class="column contact_form_header tal_c">
            <h1 class="text_lg">
              <span class="form_title">
                <span class="icon_class_1" v-html="iconSets.email"></span>
                {{ $tc("msg.contact", 1) }}
              </span>
              <span class="form_close" @click="toggleModal">X</span>
            </h1>
          </div>
          <div class="contact_form_body_body">
            <div class="column">
              <p class="text_sm">{{ $tc("msg.contact_intro", 1) }}.</p>
            </div>

            <div class="column">
              <label class="capitalize text_sm">
                <strong>{{ $tc("msg.name", 1) }}</strong>
              </label>
              <input v-model="user.name" />
            </div>

            <div class="column" v-if="member">
              <label class="capitalize text_sm">
                <strong>{{ $tc("msg.email", 1) }}*</strong>
              </label>
              <input disabled :value="member.email" />
            </div>

            <div class="column">
              <label class="capitalize text_sm">
                <strong>{{ $tc("msg.subject", 1) }}*</strong>
              </label>
              <input required v-model="user.subject" />
              <p
                class="form_warning"
                v-if="user.subject.length < minLengthSubject"
              >
                {{ $tc("msg.min_length", 1) }} {{ minLengthSubject }}
                {{ $tc("msg.characters") }}
              </p>
            </div>

            <div class="column">
              <label class="capitalize text_sm">
                <strong>{{ $tc("msg.message", 1) }}*</strong>
              </label>
              <textarea required v-model="user.message"></textarea>
              <p
                class="form_warning"
                v-if="user.message.length < minLengthMessage"
              >
                {{ $tc("msg.min_length", 1) }} {{ minLengthMessage }}
                {{ $tc("msg.characters") }}
              </p>
            </div>

            <div class="column" v-if="user">
              <button
                class="upper"
                @click="postEmail()"
                :disabled="
                  user.message.length < minLengthMessage ||
                    user.subject.length < minLengthSubject
                "
              >
                {{ $tc("msg.send", 1) }}
              </button>
            </div>
            <p class="tal_c column">
              <span class="text_sm"
                >{{ $tc("msg.email_to_registered", 1) }}.</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <base-header @showModal="toggleModal"></base-header>
    <router-view></router-view>
    <base-footer></base-footer>
  </div>
</template>
<script>
import modalVotingTen from "../../components/modals/modalVotingTen";
import modalVotingTwelve from "../../components/modals/modalVotingTwelve";
import BaseFooter from "../../components/public/BaseFooter";
import BaseHeader from "../../components/public/BaseHeader";

import modalVotingThirteen from "../../components/modals/modalVotingThirteen";

import modalBscInfo from "../../components/modals/modalBscInfo";
import modalDhbtInfo from "../../components/modals/modalDhbtInfo";
import modalNetworkDist from "../../components/modals/modalNetworkDist";
import modalPrivacyPolicy from "../../components/modals/modalPrivacyPolicy";
import modalTermsConditions from "../../components/modals/modalTermsConditions";
import modalVotingFourteenVue from "../../components/modals/modalVotingFourteen.vue";

import modalPoolInfo from "../../components/modals/modalBluePool.vue";

import { mapGetters } from "vuex";

export default {
  created() {
    this.$store.dispatch("getMember");
    this.$store.dispatch("updateBluAccount");
    this.$store.dispatch("getFeesFilter");
    this.$store.dispatch("getFundTailsBtc");
    this.getSurveyStatus();
    this.dayBlock();
    this.getVotingStatus();

    this.listNotifications();

    this.getAwnser();

    this.checkActivatedNotifications();
  },
  mounted() {},
  components: {
    BaseHeader,
    BaseFooter,
    modalTermsConditions,
    modalNetworkDist,
    modalPrivacyPolicy,
    modalBscInfo,
    modalVotingTen,
    modalDhbtInfo,
    modalVotingTwelve,
    modalPoolInfo,
    modalVotingThirteen,
    modalVotingFourteenVue
  },
  data: () => ({
    needVoting: "",
    modal: false,
    activedVolting: "",
    lastVolting: "",
    coinOne: "",
    coinTwo: "",
    user: {
      name: "",
      subject: "",
      message: ""
    },
    minLengthMessage: 10,
    minLengthSubject: 5,
    winnerCoins: [],
    volting: "",
    termsCheck: "",
    privacyCheck: "",
    notifications: "",
    modalNotificationNetwork: false,
    modalNotificationBSC: false,
    modalNotificationBlueClub: false,
    modalNotificationBluePool: false,
    needVotingNetwork: false,
    needVotingBSC: false,
    needVotingBluePool: false,
    needVotingDHBT: false,
    needVotingBlueClub: false
  }),
  methods: {
    async listNotifications() {
      let resp = await this.$store.dispatch("getNotificationList");
      if (resp.status == 200) {
        let array = resp.data;

        for (let i in array) {
          if (array[i].activated && array[i].title == "blue_club") {
            this.needVotingBlueClub = true;
            this.networkId = array[i].id;
          }

          // if (array[i].activated && array[i].title == "blue_bsc") {
          //   this.needVotingBSC = true;
          //   this.bscId = array[i].id;
          // }

          // if (array[i].activated && array[i].title == "blue_pool") {
          //   this.needVotingBluePool = true;
          //   this.bluePoolId = array[i].id;
          // }

          // if (
          //   array[i].activated &&
          //   array[i].title == "digital_horizon_blockchain"
          // ) {
          //   this.needVotingDHBT = true;
          //   this.dhbId = array[i].id;
          // }
        }

        this.notifications = resp.data;

        this.checkActivatedNotifications(this.notifications);
      } else {
        alert("Something wrong");
      }
    },

    toggleModal() {
      (this.user = {
        name: "",
        subject: "",
        message: ""
      }),
        (this.modal = !this.modal);
    },

    closeModalNetwork() {
      this.modalNotificationNetwork = false;
    },

    checkMember() {
      this.$store.dispatch("getMember");
    },

    checkTerms() {
      setTimeout(() => {
        if (this.member.optinTerms == true) {
          this.termsCheck = false;
        } else {
          this.termsCheck = true;
        }
      }, 1000);

      setTimeout(() => {
        if (this.member.optinPrivacy == true) {
          this.privacyCheck = false;
        } else {
          this.privacyCheck = true;
        }
      }, 1000);
    },

    async postEmail() {
      let userName = "unnamed";
      if (this.member.name) {
        userName = this.member.name;
      }
      if (this.user.name != "" && this.user.name != null) {
        userName = this.user.name;
      }

      let form = {
        to: "support@bluetoken.io",
        "reply-to": this.member.email,
        cc: "user@example.com",
        tagSubject: "Blu-form-contact",
        subject: this.user.subject,
        message: this.user.message
      };

      try {
        let resp = await this.$store.dispatch("postGenericEmail", form);
        this.notifySuccess(this.$t("msg.form_sent"), 3000);
        this.toggleModal();
      } catch (e) {
        this.notifyError(this.$t("msg.form_error"), 3000);
      }
    },

    async getSurveyStatus() {
      let resp = await this.$store.dispatch("getSurveyPrototypes");
      let votings = resp.data;
      for (let i in votings) {
        if (votings[i].active) {
          this.activedVolting = votings[i];
          if (votings[parseInt(i + 1)]) {
            this.lastVolting = votings[parseInt(i + 1)];
          }
        }
      }
    },

    compareDates(date1, date2) {
      if (date1 > date2) return "Date1 > Date2";
      else if (date1 < date2) return "Date2 > Date1";
      else return "Date1 = Date2";
    },

    dayBlock() {
      let date = new Date();

      let hour = date.getHours();
      let day = date.getDay() - 1;

      if (day > 11) {
        if (hour > 17) {
          return true;
        }
      } else {
        return false;
      }
    },

    async getVotingStatus() {
      try {
        let resp = await this.$store.dispatch("getSurveyPrototype");
        if (resp) {
          this.needVoting = false;
        }
      } catch (e) {
        this.needVoting = true;
        console.log(e);
      }
    },

    async checkActivatedNotifications(el) {
      let notifications = el;

      for (let i in notifications) {
        if (
          notifications[i].activated &&
          notifications[i].title == "net_dist"
        ) {
          this.notificationID = notifications[i].id;
          this.getNotificationsAnswers(notifications[i].id);
        }

        if (
          notifications[i].activated &&
          notifications[i].title == "blue_bsc"
        ) {
          this.notificationID = notifications[i].id;
          this.getNotificationsAnswersBSC(notifications[i].id);
        }

        if (
          notifications[i].activated &&
          notifications[i].title == "blue_club"
        ) {
          this.notificationID = notifications[i].id;
          this.getNotificationsAnswersDHB(notifications[i].id);
        }

        if (
          notifications[i].activated &&
          notifications[i].title == "blue_pool"
        ) {
          console.log(this.notificationID, "iiddd notification");
          this.notificationID = notifications[i].id;
          this.getNotificationsBluePool(notifications[i].id);
        }
      }
    },

    async getNotificationsAnswers(id) {
      let resp = await this.$store.dispatch("getNotificationAnswers");
      if (resp.status == 200) {
        if (resp.data.length > 0) {
          let answers = resp.data;
          for (let i in answers) {
            if (answers[i].notificationId == id) {
              this.modalNotificationBlueClub = false;
            }
          }
        } else {
          this.modalNotificationBlueClub = true;
        }
      } else {
        alert("something wrong");
      }
    },

    async getNotificationsAnswersBSC(id) {
      let resp = await this.$store.dispatch("getNotificationAnswers");
      if (resp.status == 200) {
        if (resp.data.length > 0) {
          let answers = resp.data;
          for (let i in answers) {
            if (answers[i].notificationId == id) {
              this.modalNotificationBSC = false;
            } else {
              this.modalNotificationBSC = true;
            }
          }
        }
      } else {
        alert("something wrong");
      }
    },

    async getNotificationsBluePool(id) {
      let resp = await this.$store.dispatch("getNotificationAnswers");
      if (resp.status == 200) {
        if (resp.data.length > 0) {
          let answers = resp.data;
          for (let i in answers) {
            if (answers[i].notificationId == id) {
              this.modalNotificationBluePool = false;
            } else {
              this.modalNotificationBluePool = true;
            }
          }
        } else {
          this.modalNotificationBluePool = true;
        }
      } else {
        alert("something wrong");
      }
    },

    async getNotificationsAnswersDHB(id) {
      let resp = await this.$store.dispatch("getNotificationAnswers");
      if (resp.status == 200) {
        if (resp.data.length > 0) {
          let answers = resp.data;
          for (let i in answers) {
            if (answers[i].notificationId == id) {
              this.modalNotificationDHBT = false;
            } else {
              this.modalNotificationDHBT = true;
            }
          }
        } else {
          this.modalNotificationDHBT = true;
        }
      } else {
        alert("something wrong");
      }
    },

    async postNotificationConfirm() {
      let id = this.notificationID;

      let resp = await this.$store.dispatch("postNotificationConfirm", id);
      if (resp.status == 200) {
        this.getNotificationsAnswers(id);
        this.getNotificationsAnswersBSC(id);
        this.getNotificationsAnswersDHB(id);
        this.getNotificationsBluePool(id);
      } else {
        alert("Something wrong");
      }
    },

    async getAwnser() {
      let resp = await this.$store.dispatch("getNotificationAnswers");
      if (resp.status == 200) {
        this.answers = resp.data;
      }

      // console.log(this.answers, 'caralho de asa cara')
      this.checkVouting(this.answers);
    },

    async checkVouting(el) {
      let answers = el;
      let notifications = this.notifications;

      for (let i in notifications) {
        let found = !!answers.find(
          element => element.notificationId === notifications[i].id
        );

        if (!found) {
          if (notifications[i].title == "net_dist") {
            this.modalNotificationNetwork = true;
          }

          if (notifications[i].title == "blue_bsc") {
            this.modalNotificationBSC = true;
          }

          if (notifications[i].title == "blue_club") {
            this.modalNotificationBlueClub = true;
          }

          if (notifications[i].title == "blue_pool") {
            this.modalNotificationBluePool = true;
          }
        }

        if (found) {
          if (notifications[i].title == "net_dist") {
            this.modalNotificationNetwork = false;
          }

          if (notifications[i].title == "blue_bsc") {
            this.modalNotificationBSC = false;
          }

          if (notifications[i].title == "blue_club") {
            this.modalNotificationBlueClub = false;
          }

          if (notifications[i].title == "blue_pool") {
            this.modalNotificationBluePool = false;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(["member", "bluAccount"])
  },
  watch: {
    member: function() {
      this.checkTerms();
    }

    // answers: function () {
    //   this.checkVouting();
    // },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/private/Main.vue